import { createReducer, on, Action } from '@ngrx/store';

import * as ErrorModalActions from './error-modal.actions';
import { ErrorModalModel } from './error-modal.model';

export const initialState: ErrorModalModel = {
  isVisible: false,
  errorCode: '',
  defaultContent: [],
  errorToShow: undefined,
};

const reducer = createReducer(
  initialState,
  on(ErrorModalActions.setData, (state, { data }) => ({ ...state, ...data })),
  on(ErrorModalActions.setVisiblity, (state, { isVisible }) => ({ ...state, isVisible })),
  on(ErrorModalActions.setErrorMessage, (state, { errorToShow }) => ({ ...state, errorToShow })),
  on(ErrorModalActions.setErrorMessagesList, (state, { defaultContent }) => ({ ...state, defaultContent }))
);

export function errorModalReducer(state: ErrorModalModel, action: Action) {
  return reducer(state, action);
}
